export default "__VITE_ASSET__BJi68HLG__"